import React, {Component} from 'react'
import CBaseComponent from '@/components/CBaseComponent'
import './index.scss'
import {bindActionCreators, compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {message, Modal, Button, Descriptions, Upload, Progress, Radio} from "antd";
import {getStorage} from "@/utils";
import upload from '@/assets/images/upload.png'
import Axios from "axios";
import {
  refreshMenu,
} from "../../../../redux/common/action";
import {saveitemdata,getbaseInfo} from "../../../../servers/menuAPI";
import CInput from "../../../../components/CForm/CInput";
import store from "../../../../redux";
import {getuploadfileparams, removepic} from "../../../../servers/menu";
const axios = Axios.create();

@CBaseComponent
class Legal extends Component{

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.inputChange = this.inputChange.bind(this)
    this.removeFile = this.removeFile.bind(this);
    this.beforeUpload1 = this.beforeUpload1.bind(this);
    this.confirmModal1 = this.confirmModal1.bind(this)
    this.onChangelevel = this.onChangelevel.bind(this)
  }

  state = {
    data:{},
    museumid:'',
    meseum:false,
    uploads: {
      action:'#',
      accept: '.mp4,.MP4',
      disabled: false,
      name: 'file',
      showUploadList: false,
      defaultFileList: [],//{uid: '', name: '', url: ''}
      fileList: [],
      limit: 1,//限制上传数量 默认无限制
      size: 1024*1024*100,//默认限制大小为2M
    },
  }

  inputChange(type,value){
    value = encodeURIComponent(value)
    this.setState({
      data:{...this.state.data,[type]: value}
    })
  }
  onChangelevel(type,value){
    this.setState({
      data:{...this.state.data,[type]: value.target.value}
    })
  }
  onSelect(){
    const params = {
      mimid:this.state.museumid
    }
    getbaseInfo(params).then(res=>{
      if (res.statecode === 0) {
        const result = res.records[1]
        this.setState({
          data:result
        })
      } else {
        message.error('未查询到博物馆信息');
      }
    })
  }


  onSubmit(){
    Modal.confirm({
      content: '确认保存数据',
      okText: '确认',
      cancelText: '取消',
      onCancel:()=>{
      },
      onOk:()=>{
        this.onSubmitHandler()
      }
    })
  }

  downloads(file){
    window.location.href = file
  }

  onSubmitHandler(type=''){
    if (this.state.data.content === '') {
      message.error('请输入创新综述');
      return false
    }
    saveitemdata(this.state.data).then(res=>{
      if(res.statecode === 0) {
        message.success('保存成功');
      } else {
        message.error(res.statemessage);
      }
    })
  }

  async beforeUpload1(file,data){
    if (this.state.data.files.length === 1) {
      message.info('最多可上传1个视频');
      return false;
    }
    let name = file.name;
    let size = file.size;
    let currentFileType = name.split('.').pop();
    if(size > 100*1024*1024){
      message.info('请上传视频大小控制在100MB以内');
      return false;
    }
    if(currentFileType === 'mp4' || currentFileType === 'MP4'){
      let params = {}
      params = {
        type:this.state.data.type,
        dataid:this.state.data.dataid,
        fname:name
      }
      await getuploadfileparams(params).then(res=>{
        if(res.statecode === 0) {
          let formdata = new FormData()
          formdata.append('name', file.name)
          formdata.append('key', res.records[0].key)
          formdata.append('policy', res.records[0].policy)
          formdata.append('OSSAccessKeyId', res.records[0].OSSAccessKeyId)
          formdata.append('success_action_status', res.records[0].success_action_status)
          formdata.append('callback', res.records[0].callback)
          formdata.append('signature', res.records[0].signature)
          formdata.append('x:refid', res.records[0]['x:refid'])
          formdata.append('file', file)
          axios.post(
              res.records[0].host,
              formdata,
              {
                headers:
                    { 'Content-Type': 'multipart/form-data' },
                onUploadProgress:(progressEvent)=>{
                  let processStatu = (((progressEvent.loaded / progressEvent.total) * 100) | 0) ;
                  this.setState({
                    progress:processStatu
                  })
                }
              }
          )
              .then(res => {
                if (res.status === 200 && res.data.statecode === 0) {
                  message.success('上传成功')
                  const file = this.state.data.files
                  file.push(res.data.records[0])
                  this.setState({
                    data:{...this.state.data,files:file},
                    progress:0,
                  },()=>{
                    // this.onSelect()
                  })
                } else {
                  message.error(res.statemessage)
                  this.setState({
                    progress:0,
                  })
                }
              })
              .catch(error => {
                message.error(res.statemessage)
                this.setState({
                  progress:0,
                })
              })
        } else {
          message.info(res.statemessage);
        }
      })
      return false;
    }else{
      message.info('请上传mp4格式的视频');
    }
  }

  confirmModal1 = (fileid,index) => {
    const params = {
      fileid:fileid
    }
    removepic(params).then(res=>{
      if (res.statecode === 0) {
        message.success('移除成功')
        const data = this.state.data.files
        data.splice(index,1)
        this.setState({
          data:{...this.state.data,files:data}
        })
      } else {
        message.error(res.statemessage)
      }
    })
  };

  // 移出文件
  removeFile(id,index){
    Modal.confirm({
      content: '确认移除该图片',
      okText: '确认',
      cancelText: '取消',
      onCancel:()=>{
      },
      onOk:()=>{
        this.confirmModal1(id,index)
      }
    });
  }


  handlePreview(file){
    window.open(file,'_blank')
  }

  downloads(file){
    window.open(file,'_blank')
  }

  componentDidMount(){
    const data = getStorage('userList')
    if (data.clerklevel != 8) {
      const museumid = store.getState().libraryid
      this.setState({
        museumid:museumid,
        meseum:true
      },()=>{
        this.onSelect()
      })
    } else {
      this.setState({
        museumid:data.miid+data.museumid,
      },()=>{
        this.onSelect()
      })
    }
  }

  render(){
    return (
      <div className={this.state.meseum?'store-manage-list-new base-info  base-infodisabled':'store-manage-list-new base-info'}>
        <div className='base-title'>
          <div>
            <span className='title-before-icon'></span>
            <span className='title'>创新综述</span>
          </div>
        </div>
        {
          this.state.data.videotips? <div>
            <div className='shenhe-item shenhe-itemnew'>
              <div className='shenhe-itemintro'>
                <span>创新综述</span>
                <span>【{decodeURIComponent(this.state.data.tips)}】</span>
              </div>
              <CInput placeholder="请输入创新综述" type='textarea' disabled={this.state.meseum}
                      value={decodeURIComponent(this.state.data.content)} onChange={(value) => {
                this.inputChange('content', value)
              }}/>
            </div>
            <div className='shenhe-item'>
              <div className='shenhe-itemintro'>
                <span>创新亮点视频</span>
                <span>【{decodeURIComponent(this.state.data.videotips)}】</span>
              </div>
              <div style={{width: '100%'}}>
                {
                  this.state.meseum ? '' :
                      <div style={{
                        display: 'flex',
                        justifyItems: 'flex-end',
                        flexDirection: 'column',
                        marginTop: '20px'
                      }}>
                        <Upload
                            {...this.state.uploads}
                            beforeUpload={(file, fileList) => this.beforeUpload1(file)}
                            onRemove={(file) => this.removeFile1(file)}
                        >
                          <div><Button type='primary'><img src={upload} alt=""
                                                           style={{width: '20px'}}/>上传文件</Button></div>
                        </Upload>
                        {this.state.progress > 0 ?
                            <Progress percent={this.state.progress}/> : ''
                        }
                      </div>
                }
                {this.state.data.files && this.state.data.files.map((item, index) => {
                  return (
                      <Descriptions column={{xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1}} bordered
                                    style={{marginTop: '20px'}}>
                        <Descriptions.Item label="文件名称"
                                           style={{textAlign: 'center'}}>{item.filename}</Descriptions.Item>
                        <Descriptions.Item label="操作">
                          <Button type="link" onClick={() => {
                            this.handlePreview(item.filepreviewurl)
                          }}>预览</Button>
                          <Button type="link" onClick={() => {
                            this.downloads(item.fileurl)
                          }} style={{marginLeft: '-20px'}}>下载</Button>
                          { !this.state.meseum
                              && <Button type="link" onClick={() => {
                                this.removeFile(item.fileid,index)
                              }} style={{color: 'red', marginLeft: '-20px'}}>删除</Button>
                          }
                        </Descriptions.Item>
                      </Descriptions>
                  )
                })}
              </div>
            </div>
            <div className='shenhe-item shenhe-itemnew'>
              <div className='shenhe-itemintro'>
                <span>授权中国博物馆协会无偿使用上述视频，包括但不限于制作、编辑、复制、传播、发布、展示、播放、演示等。中国博物馆协会可将视频用于宣传推广，包括但不限于网站、公众号、电视等媒体宣传。</span>
              </div>
              <Radio.Group onChange={(e) => this.onChangelevel('videoright', e)} value={this.state.data.videoright}>
                <Radio value='1'>同意</Radio>
                <Radio value='0'>不同意</Radio>
              </Radio.Group>
            </div>
            <div className='shenhe-item shenhe-itemnew'>
              <div className='shenhe-itemintro'>
                <span>创新亮点视频描述</span>
                <span>【{decodeURIComponent(this.state.data.videotexttips)}】</span>
              </div>
              <CInput placeholder="请输入创新亮点视频描述" type='textarea'
                      disabled={this.state.meseum || this.state.data.files.length === 0}
                      value={decodeURIComponent(this.state.data.videotextcontent)} onChange={(value) => {
                this.inputChange('videotextcontent', value)
              }}/>
            </div>
          </div> : ''
        }
        {!this.state.meseum &&
            <div style={{display:'flex',width:'100%',justifyContent:'center',marginTop:'20px'}}>
              <Button type="primary" onClick={() => {
                this.onSubmit()
              }}>保存</Button>
            </div>
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {};
};
const mapDispatchToProps = (dispatch) => {
  return {
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  };
};
export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Legal);

